// Module
var code = "<!--ko with: _activePage--> <!--ko template: {html: $data.GetTemplate.bind($data), afterRender: $data.AfterRender.bind($data)}--> <!--/ko--> <!--/ko-->";
// Exports
export default code;